const OPFS_PATH_SYMBOL = Symbol.for("polarr.opfsPathSegments")

type HandleWithPath = FileSystemDirectoryHandle & {
	[OPFS_PATH_SYMBOL]?: string[]
	relativePathSegments?: string[]
}

export function setOpfsPathSegments(
	handle: FileSystemDirectoryHandle,
	segments: string[],
	options: { setRelativePath?: string[] } = {},
) {
	const target = handle as HandleWithPath
	target[OPFS_PATH_SYMBOL] = [...segments]

	if (options.setRelativePath && !("relativePathSegments" in target)) {
		Object.defineProperty(target, "relativePathSegments", {
			value: [...options.setRelativePath],
			writable: false,
			configurable: false,
		})
	}
}

export function getOpfsPathSegments(
	handle?: FileSystemDirectoryHandle | null,
): string[] | undefined {
	if (!handle) {
		return undefined
	}
	const target = handle as HandleWithPath
	return target[OPFS_PATH_SYMBOL] ? [...target[OPFS_PATH_SYMBOL]] : undefined
}
